interface DocumentMetaProps {
  title: string;
  description?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
}

/**
 * Declarative SEO metadata component using React 19 head hoisting.
 *
 * Renders `<title>`, `<meta name="description">`, and Open Graph tags
 * that React 19 automatically hoists into `<head>`.
 *
 * @see research.md R1 — SEO Metadata Strategy (FR-023)
 */
export function DocumentMeta({
  title,
  description,
  ogTitle,
  ogDescription,
  ogType = "website",
}: DocumentMetaProps) {
  const resolvedOgTitle = ogTitle ?? title;
  const resolvedOgDescription = ogDescription ?? description;

  return (
    <>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <meta property="og:title" content={resolvedOgTitle} />
      {resolvedOgDescription && (
        <meta property="og:description" content={resolvedOgDescription} />
      )}
      <meta property="og:type" content={ogType} />
    </>
  );
}
